import React from "react";
import { Callout, RichText } from "@bared/ui";

export const SearchListEmpty = () => {
  const title = `No products were found.`;
  const subtitle = `Try clearing some of your filters.`;

  return (
    <Callout
      className="ml-midi w-[fit-content]"
      variant="secondary"
      size="large"
    >
      <RichText>
        <p>
          {title} {subtitle}
        </p>
      </RichText>
    </Callout>
  );
};
